export default __webpack_public_path__ + "assets/img/ict-text.57e3a58597e91bae5ac6912a2d63d8de.svg";